import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import {
  deleteAllRecentSearches,
  getCustomizedResultsSettings,
  getRecentSearches,
} from './api'
import {
  CustomizedResultsSetting,
  SearchListItem,
} from '@user/store/search/typings'

const recentlyVisitedAdapter = createEntityAdapter<SearchListItem>({
  selectId: (entity) => entity.entityId,
})

const customizedResultsSettingAdapter =
  createEntityAdapter<CustomizedResultsSetting>({
    selectId: (entity) => entity.id,
  })

export const initialState = {
  recentSearches: recentlyVisitedAdapter.getInitialState(),
  customizedResultsSettings: customizedResultsSettingAdapter.getInitialState(),
}

export const globalSearch = createSlice({
  name: 'globalSearch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRecentSearches.fulfilled, (state, { payload }) => {
      recentlyVisitedAdapter.setAll(state.recentSearches, payload)
    })
    builder.addCase(deleteAllRecentSearches.fulfilled, (state) => {
      recentlyVisitedAdapter.removeAll(state.recentSearches)
    })
    builder.addCase(
      getCustomizedResultsSettings.fulfilled,
      (state, { payload }) => {
        customizedResultsSettingAdapter.setAll(
          state.customizedResultsSettings,
          payload,
        )
      },
    )
  },
})

export default globalSearch.reducer

export const recentlyVisitedAdapterSelectors =
  recentlyVisitedAdapter.getSelectors<StoreData>(
    (state) => state.globalSearch.recentSearches,
  )

export const customizedResultsSettingAdapterSelectors =
  customizedResultsSettingAdapter.getSelectors<StoreData>(
    (state) => state.globalSearch.customizedResultsSettings,
  )

export const { selectAll: selectAllRecentlyVisitedRecords } =
  recentlyVisitedAdapterSelectors

export const { selectAll: selectAllCustomizedResultsSettings } =
  customizedResultsSettingAdapterSelectors
